import { LegalPage, LegalSection } from "../../components/shared/LegalPage";

export default function PolitiqueCookiesPage() {
  return (
    <LegalPage
      overline="Navigation"
      title="Politique relative aux"
      accent="cookies"
      intro="Cette politique explique quels cookies et technologies similaires sont utilisés sur ce site et pourquoi."
      testId="legal-cookies-page"
    >
      <LegalSection title="Cookies strictement nécessaires" testId="legal-cookies-necessaires">
        <p>
          Ce site utilise uniquement des cookies et technologies similaires strictement nécessaires à son
          fonctionnement. Ils ne nécessitent pas votre consentement préalable et permettent notamment :
        </p>
        <ul className="list-disc space-y-1.5 pl-5">
          <li><span className="font-semibold">Authentification et session</span> : vous maintenir connecté à votre espace client ;</li>
          <li><span className="font-semibold">Sécurité</span> : protéger votre compte et le site ;</li>
          <li><span className="font-semibold">Fonctionnement des comptes</span> : accéder à vos événements, documents et échanges ;</li>
          <li><span className="font-semibold">Sélection et réservation</span> : conserver votre sélection de produits et vos dates pendant votre navigation ;</li>
          <li><span className="font-semibold">Prévention des abus</span> : limiter les usages frauduleux ou automatisés ;</li>
          <li><span className="font-semibold">Paiement</span> : sécuriser les transactions lorsque nécessaire.</li>
        </ul>
      </LegalSection>

      <LegalSection title="Paiement sécurisé — Stripe" testId="legal-cookies-stripe">
        <p>
          Dans le cadre du règlement de vos commandes, notre prestataire de paiement Stripe peut utiliser les cookies
          et technologies strictement nécessaires à la sécurisation et au traitement des paiements (prévention de la
          fraude, authentification de la transaction).
        </p>
      </LegalSection>

      <LegalSection title="Mesure d'audience et traceurs facultatifs" testId="legal-cookies-mesure">
        <p>
          À ce jour, <span className="font-semibold">aucun outil de mesure d'audience ni aucun traceur facultatif n'est actif</span>{" "}
          sur ce site.
        </p>
        <p>
          Un outil de mesure d'audience (par exemple Google Analytics) pourrait être envisagé à l'avenir. Si des
          traceurs facultatifs nécessitant votre consentement sont ajoutés ultérieurement, ils resteront désactivés
          avant votre consentement, et vous pourrez à tout moment accepter, refuser ou modifier votre choix.
        </p>
      </LegalSection>

      <LegalSection title="Gérer les cookies" testId="legal-cookies-gestion">
        <p>
          Vous pouvez configurer votre navigateur pour être informé de l'enregistrement de cookies ou les refuser.
          Attention : le blocage des cookies strictement nécessaires peut empêcher le bon fonctionnement du site
          (connexion à votre compte, sélection de produits, paiement).
        </p>
        <p>
          Pour toute question relative à cette politique :{" "}
          <a href="mailto:contact@art-events.fr" className="font-semibold text-deepgreen underline underline-offset-2 hover:text-gold" data-testid="legal-cookies-contact-link">
            contact@art-events.fr
          </a>
          .
        </p>
      </LegalSection>
    </LegalPage>
  );
}
